import type {GuestSharedTrustAccountDTO} from '@sollapay/types';

export type GuestAccountInviter = NonNullable<GuestSharedTrustAccountDTO['invitedBy']>;

export interface GuestFirmGroup {
  firm: GuestSharedTrustAccountDTO['firm'];
  accounts: GuestSharedTrustAccountDTO[];
  inviters: GuestAccountInviter[];
}

export const getGuestInviterName = (account: {invitedBy: GuestAccountInviter | null}) =>
  account.invitedBy?.name ?? '';

/** Groups the guest's accounts by firm, keeping the order each firm and account first appears in. */
export function groupGuestAccountsByFirm(accounts: GuestSharedTrustAccountDTO[]): GuestFirmGroup[] {
  const groups = new Map<string, Omit<GuestFirmGroup, 'inviters'>>();
  for (const account of accounts) {
    const group = groups.get(account.firm.id);
    if (group) group.accounts.push(account);
    else groups.set(account.firm.id, {firm: account.firm, accounts: [account]});
  }
  return [...groups.values()].map(group => ({
    ...group,
    inviters: rankInviters(group.accounts)
  }));
}

/** Distinct named inviters, the one behind the most recent share first. */
function rankInviters(accounts: GuestSharedTrustAccountDTO[]): GuestAccountInviter[] {
  const byRecency = [...accounts].sort((a, b) => b.sharedAt.localeCompare(a.sharedAt));
  const inviters = new Map<string, GuestAccountInviter>();
  for (const {invitedBy} of byRecency) {
    if (invitedBy?.name && !inviters.has(invitedBy.id)) inviters.set(invitedBy.id, invitedBy);
  }
  return [...inviters.values()];
}
